<template>
  <toast-notification ref="notification" />
  <loading-spinner
    ref="spinner"
    spinnerType="border"
    color="primary"
  ></loading-spinner>

  <div
    class="justify-content-center my-3 scrollable-vertical scrollable-styled-dark"
    :class="isMobile ? '' : 'row'"
    :style="isMobile ? '' : 'max-height: 70vh'"
  >
    <div class="col-md-10">
      <div class="accordion" id="accordionShadow">
        <div class="card mb-2 shadow border-0">
          <div
            class="card-header mb-0 p-0 border-0 bg-light"
            id="cleanHeadingOne"
          >
            <h2 class="mb-0">
              <button
                class="btn btn-blueSite w-100 btn-lg text-align-start text-decoration-none"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#shadowCollapseOne"
                :aria-expanded="isMobile ? 'false' : 'true'"
                aria-controls="shadowCollapseOne"
              >
                <span :class="isMobile ? 'fs14px' : ''">
                  افزایش موجودی کیف پول
                </span>

                <span class="group-icon float-end">
                  <i class="fi fi-arrow-start-slim"></i>
                  <i class="fi fi-arrow-down-slim"></i>
                </span>
              </button>
            </h2>
          </div>

          <div
            id="shadowCollapseOne"
            class="collapse"
            :class="isMobile ? '' : 'show'"
            aria-labelledby="cleanHeadingOne"
            data-bs-parent="#accordionShadow"
          >
            <div
              class="card-body shadow"
              v-if="!approvingIPG"
              :class="isMobile ? 'p-0 px-3' : ''"
            >
              <div class="row justify-content-center">
                <div class="col-md-10 my-1 p-3 rounded border shadow">
                  <combo-box-with-message
                    ref="walletSelect"
                    :combo-list="WalletList()"
                    :disabled="true"
                    comboClass="mt-2"
                    itemKey="id"
                    itemValue="title"
                    topTitle="کیف پول مورد نظر خود را انتخاب کنید:"
                    :required="true"
                    comboSize="sm"
                    topTitleClass="mb-1"
                    v-model:selectedItem="entity.walletID"
                    errorText="کیف پول مورد نظر خود را انتخاب کنید"
                    errorClass="text-danger smaller"
                    warningSelectRow=""
                  />
                  <combo-box-with-message
                    ref="paymentTypeSelect"
                    :combo-list="paymentTypeList"
                    comboClass="mt-2"
                    itemKey="id"
                    itemValue="title"
                    :disabled="this.currencyWallet"
                    topTitle="نوع تراکنش را مشخص کنید:"
                    :required="true"
                    comboSize="sm"
                    topTitleClass="mb-1"
                    v-model:selectedItem="entity.paymentTypeID"
                    errorText="نوع تراکنش را مشخص کنید"
                    errorClass="text-danger smaller"
                    warningSelectRow=""
                  />

                  <input-with-message
                    ref="priceInput"
                    containerClass="mt-2"
                    errorMessage="وارد کردن مقدار مبلغ الزامی است"
                    erroMessageClass="text-danger smaller"
                    topTitle="مبلغ مورد نظر را وارد کنید:"
                    :required="true"
                    :iconSpin="false"
                    inputType="intNumber"
                    :showMessage="false"
                    :hasLeftBox="true"
                    :showIcon="false"
                    :hasSideBox="true"
                    :isDigitSeprator="true"
                    :showDigiTranslate="true"
                    :leftBoxTitle="getWalletCurrencyTitle()"
                    topTitleClass="mb-1"
                    v-model:inputValue="entity.price"
                    input-size="sm"
                  />
                  <date-time-picker
                    ref="dateTimeInput"
                    v-if="entity.paymentTypeID == 6"
                    color="#506690"
                    errorMessage="وارد کردن مقدار تاریخ و ساعت واریز الزامی است"
                    topTitleClass="mb-1"
                    dateTimePickerClass="test-class"
                    placeholder=""
                    v-model:dateTime="entity.dateTime"
                    topTitle="تاریخ و ساعت واریز را وارد نمایید:"
                    :required="true"
                    :clearable="true"
                    containerClass="mt-2"
                    type="datetime"
                  />
                  <div class="mt-2" v-show="entity.paymentTypeID == 6">
                    <label for="Attachment"
                      >تصویر رسید واریز را بارگزاری کنید:</label
                    ><span data-v-3ed89cc4="" class="text-danger mx-1">*</span>
                    <div class="input-group">
                      <span class="input-group-addon"
                        ><i class="fa fa-paperclip"></i></span
                      ><input
                        class="form-control form-control-sm custom-file-upload custom-file-upload-hidden"
                        data-btn-text="انتخاب"
                        id="formFileReceipt"
                        name="formFileReceipt"
                        type="file"
                        @input="fileReceiptInput"
                        value=""
                        tabindex="-1"
                        style="position: absolute"
                      /><input
                        type="text"
                        id="inputFileName"
                        ref="inputFileName"
                        disabled
                        class="form-control form-control-sm file-upload-input text-left"
                        :class="{ isNotValid: !fileReceiptValidate }"
                      /><span class="me-1 input-group-btn" tabindex="-1">
                        <button
                          class="btn btn-sm btn-light ps-2"
                          id="btnUploadReceiptFile"
                          @click="btnUploadReceiptFileClick"
                        >
                          <i class="fi fi-folder-empty"></i>
                        </button>
                      </span>
                    </div>
                    <span class="text-danger" v-if="overLimitationImageSize"
                      >حجم فایل انتخاب شده نمی‌تواند بیشتر از
                      <strong
                        >{{
                          this.$store.state.fileUploadLimitation.receiptFile
                            .size
                        }}
                        {{
                          this.$store.state.fileUploadLimitation.receiptFile
                            .type == 'MB'
                            ? 'مگابایت'
                            : this.$store.state.fileUploadLimitation.receiptFile
                                .type == 'KB'
                            ? 'کیلوبایت'
                            : ''
                        }}</strong
                      >
                      باشد.</span
                    >
                    <div v-if="!fileReceiptValidate">
                      <span class="text-danger smaller"
                        >انتخاب فایل مربوط به رسید واریز الزامی است</span
                      >
                    </div>
                    <span
                      class="field-validation-valid text-danger"
                      data-valmsg-for="Attachment"
                      data-valmsg-replace="true"
                    ></span>
                  </div>
                  <input-with-message
                    copmponentType="textArea"
                    containerClass="col-12 mt-2"
                    topTitle="توضیحات:"
                    v-if="false"
                    inputThem="grayThem"
                    :iconSpin="false"
                    inputType="text"
                    :showMessage="false"
                    v-model:inputValue="entity.description"
                    :hasSideBox="false"
                  />
                  <div
                    class="text-danger p-2 mt-2 justified"
                    v-if="entity.paymentTypeID == 6"
                  >
                    <div>
                      <!-- <i class="fi fi-orbit fi-spin fs-4"></i> -->

                      توجه: پس از ثبت اطلاعات نتیجه حداکثر تا ۱۲ ساعت آینده به
                      اطلاع شما خواهد رسید. از شکیبایی شما سپاسگزاریم.
                    </div>
                  </div>

                  <div class="text-center mt-2">
                    <button
                      class="btn btn-sm rounded btn-danger"
                      @click="approveButtonClick"
                    >
                      <i class="fi fi-box-checked"></i>
                      افزایش موجودی
                    </button>
                    <button
                      class="btn btn-sm rounded btn-blueSite"
                      @click="cancelButtonClick"
                    >
                      <i class="fi mdi-close"></i>
                      لغو
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body shadow" v-if="approvingIPG">
              <div class="row justify-content-center">
                <div class="col-md-10 my-1 p-3 rounded border shadow">
                  <div class="text-center">
                    <label class="small">مبلغ شارژ:</label>
                    <span class="me-2"
                      ><b>{{ getThousand(entity.price) }}</b>
                      <span class="smaller"> ریال</span></span
                    >
                  </div>
                  <div class="text-center" v-if="ipgProvider == 'PayPing'">
                    <label class="small">مبلغ کارمزد:</label>
                    <span class="me-2"
                      ><b>{{ getThousand(this.wageAmount) }}</b>
                      <span class="smaller"> ریال</span></span
                    >
                  </div>
                  <hr class="hr-conclusion" />

                  <div class="text-center" v-if="ipgProvider == 'PayPing'">
                    <label class="small">مبلغ قابل پرداخت:</label>
                    <span class="me-2"
                      ><b>{{
                        getThousand(Number(entity.price) + wageAmount)
                      }}</b>
                      <span class="smaller"> ریال</span>
                    </span>
                  </div>
                  <div class="text-center mt-4">
                    <a
                      class="btn btn-sm rounded btn-success text-white"
                      :href="ipgLink"
                    >
                      <i class="fi fi-layerstore" v-if="!isMobile"></i>
                      انتقال به درگاه پرداخت
                    </a>
                    <button
                      class="btn btn-sm rounded btn-danger"
                      @click="cancelApproveIPGButtonClick"
                    >
                      <i class="fi mdi-close" v-if="!isMobile"></i>
                      لغو عملیات
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="card mb-2 shadow border-0"
          v-if="getCurrentWalletCurrencyType() == 1"
        >
          <div
            class="card-header mb-0 p-0 border-0 bg-light"
            id="cleanHeadingTwo"
          >
            <h2 class="mb-0">
              <button
                class="btn btn-softBlueSite w-100 btn-lg text-align-start text-decoration-none collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#shadowCollapseTwo"
                aria-expanded="false"
                aria-controls="shadowCollapseTwo"
              >
                <span :class="isMobile ? 'fs14px' : ''"
                  >افزودن موجودی به کیف پول سایر کاربران (درگاه بانکی)</span
                >

                <span class="group-icon float-end">
                  <i class="fi fi-arrow-start-slim"></i>
                  <i class="fi fi-arrow-down-slim"></i>
                </span>
              </button>
            </h2>
          </div>

          <div
            id="shadowCollapseTwo"
            class="collapse"
            aria-labelledby="cleanHeadingTwo"
            data-bs-parent="#accordionShadow"
          >
            <div class="card-body shadow" v-if="!approvingOtherIPG">
              <div class="row justify-content-center">
                <div class="col-md-10 my-1 p-3 rounded border shadow">
                  <div id="passwordHelpBlock" class="form-text mb-2">
                    شماره عضویت مراجعه‌کننده‌ای را که مایل به افزایش موجودی
                    ایشان هستید را وارد نمایید:
                  </div>
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      :class="{ isNotValid: !validatedSearchClientCode }"
                      placeholder=""
                      aria-label="شماره عضویت را وارد "
                      aria-describedby="button-addon2"
                      v-model="searchClientCode"
                    />
                    <!-- @input="clientCodeOnInput()" -->
                    <button
                      class="btn btn-blueSite"
                      type="button"
                      @click="findClientCode"
                    >
                      <i class="fi fi-search pe-2"></i>
                    </button>
                  </div>

                  <div>
                    <span
                      v-if="!validatedSearchClientCode"
                      class="smaller text-danger"
                      >وارد کردن شماره عضویت الزامی است</span
                    >
                  </div>
                  <!-- <div class="row">
                    <div class="col-md-9">
                      <div class="form-floating mb-3">
                        <floating-input-with-message
                          containerClass="mb-3"
                          inputType="text"
                          ID="clientCodeInput"
                          ref="clientCodeInput"
                          inputPlaceHolder="ClientCode"
                          v-model:inputValue="searchClientCode"
                          labelClass="text-muted small"
                          labelValue="شماره عضویت"
                          errorMessage="وارد کردن شماره عضویت الزامی است"
                          erroMessageClass="smaller text-danger"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <button
                        type="submit"
                        class="btn btn-blueSite mt-1"
                        @click="searchClientCode"
                      >
                        <i class="fi fi-search"></i>
                        جستجو
                      </button>
                    </div>
                  </div> -->
                </div>
              </div>

              <div
                class="row justify-content-center"
                v-if="otherClientForChargeEntity.clientCode != ''"
              >
                <div class="col-md-10 my-1 p-3 rounded border shadow">
                  <input-with-message
                    containerClass="mt-2"
                    errorMessage=""
                    topTitle="شماره عضویت:"
                    :required="true"
                    :iconSpin="false"
                    inputType="text"
                    :disableInput="true"
                    :showMessage="false"
                    :hasLeftBox="false"
                    :showIcon="false"
                    :hasSideBox="true"
                    topTitleClass="mb-1"
                    v-model:inputValue="otherClientForChargeEntity.clientCode"
                    input-size="sm"
                  />
                  <!-- <input-with-message
                    containerClass="mt-2"
                    errorMessage=""
                    topTitle="نام مراجع:"
                    :required="true"
                    :iconSpin="false"
                    inputType="text"
                    :disableInput="true"
                    :showMessage="false"
                    :hasLeftBox="false"
                    :showIcon="false"
                    :hasSideBox="true"
                    topTitleClass="mb-1"
                    v-model:inputValue="
                      otherClientForChargeEntity.clientFullName
                    "
                    input-size="sm"
                  /> -->
                  <combo-box-with-message
                    :combo-list="paymentTypeList"
                    comboClass="mt-2"
                    itemKey="id"
                    itemValue="title"
                    :disabled="true"
                    topTitle="نوع عملیات:"
                    :required="true"
                    comboSize="sm"
                    topTitleClass="mb-1"
                    v-model:selectedItem="otherChargeEntity.paymentTypeID"
                    errorText="نوع عملیات را انتخاب کنید"
                    errorClass="text-danger smaller"
                    warningSelectRow=""
                  />
                  <input-with-message
                    ref="otherClientPriceInput"
                    containerClass="mt-2"
                    errorMessage="وارد کردن مقدار مبلغ الزامی است"
                    erroMessageClass="text-danger smaller"
                    topTitle="مبلغ:"
                    :required="true"
                    :iconSpin="false"
                    inputType="intNumber"
                    :showMessage="false"
                    :hasLeftBox="true"
                    :showIcon="false"
                    :hasSideBox="true"
                    :isDigitSeprator="true"
                    :showDigiTranslate="true"
                    :leftBoxTitle="getWalletCurrencyTitle()"
                    topTitleClass="mb-1"
                    v-model:inputValue="otherChargeEntity.price"
                    input-size="sm"
                  />
                  <input-with-message
                    copmponentType="textArea"
                    containerClass="col-12 mt-2"
                    topTitle="توضیحات:"
                    inputThem="grayThem"
                    :iconSpin="false"
                    inputType="text"
                    :showMessage="false"
                    v-model:inputValue="otherChargeEntity.description"
                    :hasSideBox="false"
                  />
                  <div class="text-center mt-2">
                    <button
                      class="btn btn-sm rounded btn-blueSite"
                      @click="approveOtherClientButtonClick"
                    >
                      <i class="fi fi-box-checked"></i>
                      تایید
                    </button>
                    <button
                      class="btn btn-sm rounded btn-blueSite"
                      @click="cancelButtonClick"
                    >
                      <i class="fi mdi-close"></i>
                      انصراف
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body shadow" v-if="approvingOtherIPG">
              <div class="row justify-content-center">
                <div class="col-md-10 my-1 p-3 rounded border shadow">
                  <div class="text-center">
                    <label class="small">مبلغ شارژ:</label>
                    <span class="me-2"
                      ><b>{{ getThousand(otherChargeEntity.price) }}</b>
                      <span class="smaller"> ریال</span></span
                    >
                  </div>
                  <div class="text-center" v-if="ipgProvider == 'PayPing'">
                    <label class="small">مبلغ کارمزد:</label>
                    <span class="me-2"
                      ><b>{{ getThousand(this.wageAmount) }}</b>
                      <span class="smaller"> ریال</span></span
                    >
                  </div>
                  <hr class="hr-conclusion" />

                  <div class="text-center" v-if="ipgProvider == 'PayPing'">
                    <label class="small">مبلغ قابل پرداخت:</label>
                    <span class="me-2"
                      ><b>{{
                        getThousand(
                          Number(otherChargeEntity.price) + this.wageAmount
                        )
                      }}</b>
                      <span class="smaller"> ریال</span>
                    </span>
                  </div>
                  <div class="text-center mt-4">
                    <a
                      class="btn btn-sm rounded btn-success text-white"
                      :href="ipgLink"
                    >
                      <i class="fi fi-layerstore" v-if="!isMobile"></i>
                      انتقال به درگاه پرداخت
                    </a>
                    <button
                      class="btn btn-sm rounded btn-danger"
                      @click="cancelApproveIPGButtonClick"
                    >
                      <i class="fi mdi-close" v-if="!isMobile"></i>
                      لغو عملیات
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import ComboBoxWithMessage from '../../../../components/form/comboBoxWithMessage/ComboBoxWithMessage.vue';
// import FloatingInputWithMessage from '../../../../components/form/floatingInputWithMessage/FloatingInputWithMessage.vue';
import InputWithMessage from '../../../../components/form/inputWithMessage/InputWithMessage.vue';
import DateTimePicker from '../../../../components/form/dateTimePicker/DateTimePicker.vue';
import axios from 'axios';
import { isMobile } from 'mobile-device-detect';

export default {
  components: {
    LoadingSpinner,
    ComboBoxWithMessage,
    DateTimePicker,
    InputWithMessage,
    // FloatingInputWithMessage,
  },
  inject: ['WalletList', 'SetSelectedTab'],
  data() {
    return {
      overLimitationImageSize: false,
      frFile: '',
      isMobile: isMobile,
      searchClientCode: '',
      validatedSearchClientCode: true,
      paymentTypeList: [],
      currencyWallet: false,
      fileReceiptValidate: true,
      approvingIPG: false,
      approvingOtherIPG: false,
      ipgProvider: 'Samaan',
      ipgLink: null,
      wageAmount: 10000,
      entity: {
        id: 0,
        walletID: 0,
        price: 0,
        dateTime: '',
        statusID: 1,
        receiptFileName: null,
        paymentTypeID: 0,
      },
      otherChargeEntity: {
        // id: 0,
        // walletID: 0,
        price: 0,
        // statusID: 1,
        paymentTypeID: 5,
        description: '',
      },
      otherClientForChargeEntity: {
        // id: 0,
        currencyTypeID: 1,
        clientCode: '',
        // personID: 0,
        // clientFullName: '',
      },
    };
  },
  props: {
    selectedWalletID: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  methods: {
    getWalletCurrencyTitle() {
      let wallet = this.WalletList().filter(
        (f) => f.id == this.selectedWalletID
      );
      if (wallet.length > 0) {
        this.currencyWallet = wallet[0].currencyTypeID != 1;
        if (this.currencyWallet) {
          this.entity.paymentTypeID = 6;
        }
        return wallet[0]?.wallet_CurrencyType?.title;
      }
      return '';
    },
    getCurrentWalletCurrencyType() {
      let wallet = this.WalletList().filter(
        (f) => f.id == this.selectedWalletID
      );
      if (wallet.length > 0) {
        return wallet[0]?.currencyTypeID;
      }
      return -1;
    },
    cancelButtonClick() {
      this.SetSelectedTab('walletList');
      this.resetEntity();
    },
    btnUploadReceiptFileClick() {
      document.getElementById('formFileReceipt').click();
    },
    async getCurrentIPGProvider() {
      this.ipgProvider = 'Samaan';

      this.$refs.spinner.show();
      await axios
        .get('/FN/PayPingIPG/GetCurrentIPGType')
        .then((response) => {
          this.ipgProvider = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async getWageAmount() {
      if (this.ipgProvider == 'Samaan') {
        this.wageAmount = 0;
        return;
      }
      this.$refs.spinner.show();
      await axios
        .get('/FN/PayPingIPG/GetCurrentWageAmount')
        .then((response) => {
          this.wageAmount = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    validate() {
      if (!this.entity.paymentTypeID) {
        this.$refs.paymentTypeSelect.showErrorMessage();
        this.$refs.paymentTypeSelect.setFocus();
        return false;
      }
      if (!this.entity.price) {
        this.$refs.priceInput.showErrorMessage();
        this.$refs.priceInput.setFocus();
        return false;
      }
      if (this.entity.paymentTypeID == 6 && !this.entity.dateTime) {
        this.$refs.dateTimeInput.showErrorMessage();
        return false;
      }

      if (this.entity.paymentTypeID == 6 && !this.entity.receiptFileName) {
        this.fileReceiptValidate = false;
        return false;
      }

      return true;
    },
    validateOtherIncrease() {
      if (!this.otherChargeEntity.price) {
        this.$refs.otherClientPriceInput.showErrorMessage();
        this.$refs.otherClientPriceInput.setFocus();
        return false;
      }

      return true;
    },
    resetEntity() {
      this.entity = new Object({
        id: 0,
        walletID: 0,
        price: 0,
        dateTime: null,
        statusID: 1,
        receiptFileName: null,
        paymentTypeID: 0,
      });
      this.frFile = '';

      this.fileReceiptValidate = true;
    },
    getThousand(amount) {
      /* eslint-disable */
      return thousandSeprator(amount);
    },
    async fileReceiptInput(e) {
      if (e.target.files.length == 0) {
        return;
      }
      let limitationSize = 0;
      let limitationTitle = '';

      switch (this.$store.state.fileUploadLimitation.receiptFile.type) {
        case 'MB':
          limitationSize =
            this.$store.state.fileUploadLimitation.receiptFile.size * 1024;
          limitationTitle = 'مگابایت';
          break;
        case 'KB':
          limitationSize =
            this.$store.state.fileUploadLimitation.receiptFile.size;
          limitationTitle = 'کیلوبایت';
          break;
      }

      // eslint-disable-next-line
      if (!CheckFileSize(e.target.files[0], limitationSize)) {
        this.overLimitationImageSize = true;
        this.$refs.notification.show({
          type: 'error',
          title: `حجم فایل انتخاب شده نمی‌تواند بیشتر از ${this.$store.state.fileUploadLimitation.receiptFile.size} ${limitationTitle} باشد`,
        });
        this.entity.receiptFileName = null;
        this.$refs.inputFileName.value = null;
        return;
      }
      this.overLimitationImageSize = false;
      this.entity.receiptFileName = e.target.files[0].name;
      this.$refs.inputFileName.value = this.entity.receiptFileName;
      this.frFile = e.target.files[0];
      this.fileReceiptValidate = true;
    },
    async approveButtonClick() {
      let that = this;
      if (!this.validate()) {
        return;
      }
      //فیش واریزی باشد
      if (this.entity.paymentTypeID == 6) {
        this.$refs.spinner.show();
        let formData = new FormData();
        for (var key in this.entity) {
          formData.append(key, this.entity[key]);
        }
        formData.append('ReceiptFile', this.frFile);
        await axios
          .post('/ST/RechargeWallet/CreateRechargeWallet', formData)
          .then((response) => {
            if (!response?.data?.success) {
              let errorMessages = response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                this.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
              return;
            }
            if (response?.data?.success) {
              this.$refs.notification.show({
                type: 'success',
                title: 'اطلاعات با موفقیت ثبت شد',
              });
              this.cancelButtonClick();
            }
          })
          .catch((error) => {
            if (!error.response.data.success) {
              let errorMessages = error.response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                that.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
              if (errorMessages && errorMessages.length > 0) return;
            }

            this.$refs.notification.show({
              type: 'error',
              title: `ثبت اطلاعات با خطا مواجه گردید.`,
            });
          })
          .finally(() => {
            this.$refs.spinner.hide();
          });
      }
      //درگاه پرداخت سایت
      if (this.entity.paymentTypeID == 5) {
        let url =
          this.ipgProvider == 'Samaan'
            ? '/FN/SamaanIPG/CreateSamaanIPG'
            : '/FN/PayPingIPG/CreatePayPingIPG';

        this.$refs.spinner.show();
        await axios
          .post(url, {
            amount: this.entity.price,
            walletID: this.selectedWalletID,
            // clientName: this.$store?.getters?.userFullName,
            // ClientPhoneEmail: this.getClientPhoneEmail(),
            description: this.entity.description,
          })
          .then((response) => {
            if (!response?.data?.success) {
              let errorMessages = response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                this.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
              return;
            }
            if (response?.data?.success) {
              this.ipgLink = response?.data?.returnValue;
              this.approvingIPG = true;
            }
          })
          .catch((error) => {
            if (!error.response.data.success) {
              let errorMessages = error.response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                that.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
              if (errorMessages && errorMessages.length > 0) return;
            }
            this.$refs.notification.show({
              type: 'error',
              title: `اتصال به درگاه پرداخت با خطا مواجه گردید.`,
            });
          })
          .finally(() => {
            this.$refs.spinner.hide();
          });
      }
    },
    // clientCodeOnInput() {
    //   this.validatedSearchClientCode = true;
    // },
    async findClientCode() {
      if (!this.searchClientCode) {
        this.validatedSearchClientCode = false;
        return;
      }
      this.validatedSearchClientCode = true;
      this.$refs.spinner.show();
      let that = this;
      await axios
        .get(
          `/FN/Wallet/GetPersonWalletByClientCode?code=${this.searchClientCode}&&id=${that.$store.getters.userPersonID}`
        )
        .then((response) => {
          if (!response.data) {
            this.$refs.notification.show({
              type: 'error',
              title: `مراجع مورد نظر یافت نشد`,
            });

            that.otherClientForChargeEntity = new Object({
              id: 0,
              currencyTypeID: 1,
              clientCode: '',
              personID: 0,
              clientFullName: '',
            });

            return;
          }
          //   if (!response?.data?.success) {
          //     let errorMessages = response.data.errors.map((i) => i.errorMessage);
          //     errorMessages.forEach((item) => {
          //       this.$refs.notification.show({
          //         type: 'error',
          //         title: item,
          //       });
          //     });
          //     return;
          //   }
          //that.otherChargeEntity.walletID = response.data.id;
          that.otherClientForChargeEntity = response.data;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `دریافت اطلاعات مراجع با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    getClientPhoneEmail() {
      return this.$store.getters.phone ?? this.$store.getters.email ?? '';
    },

    cancelApproveIPGButtonClick() {
      this.approvingIPG = false;
      this.approvingOtherIPG = false;
    },
    async approveOtherClientButtonClick() {
      if (!this.validateOtherIncrease()) {
        return;
      }
      let that = this;
      let url =
        this.ipgProvider == 'Samaan'
          ? '/FN/SamaanIPG/CreateIPGForChargingOtherClient'
          : '/FN/PayPingIPG/CreateIPGForChargingOtherClient';
      this.$refs.spinner.show();
      await axios
        .post(url, {
          amount: that.otherChargeEntity.price,
          clientCode: that.searchClientCode,
          description: that.otherChargeEntity.description,
        })
        .then((response) => {
          if (!response?.data?.success) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            return;
          }
          if (response?.data?.success) {
            this.ipgLink = response?.data?.returnValue;
            this.approvingOtherIPG = true;
          }
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `اتصال به درگاه پرداخت با خطا مواجه گردید.`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
  },

  async mounted() {
    // let that = this;

    this.paymentTypeList = [
      { id: 5, title: 'درگاه پرداخت' },
      { id: 6, title: 'فیش واریزی' },
    ];

    this.entity.walletID = this.selectedWalletID;

    document.getElementById('formFileReceipt').oninput = ((e) => {}).bind(this);
    await this.getCurrentIPGProvider();
    await this.getWageAmount();
  },
};
</script>
<style scoped>
.hr-conclusion {
  background: -webkit-gradient(
    radial,
    50% 50%,
    0,
    50% 50%,
    150,
    from(#000),
    to(#fff)
  ) !important;
}
</style>
<style>
.test-class {
  scale: 0.85;
}
</style>
